<template>
  <div>
    <TopMenu @scroll="scroll" />
    <v-container style="margin-top: 150px">
      <v-row dense>
        <v-col cols="12" md="6" sm="6">
          <v-col
            cols="12"
            md="12"
            sm="12"
            class="d-flex align-center justify-start mt-0 pt-0"
          >
            <h2 class="gradient bolder">
              Quer ter flexibilidade de horário , liberdade financeira e
              geográfica?
            </h2>
          </v-col>

          <v-col
            cols="12"
            md="10"
            sm="10"
            class="d-flex align-center justify-start ma-0 pa-0 flex-column"
          >
            <span class="ml-4 mt-4">
              O Professor Licenciado tem autonomia para
              <strong>gerenciar sua própria agenda</strong>, captar alunos
              utilizando
              <strong
                >o método de vendas do Pitch, negociar valores diretamente com
                os alunos</strong
              >
              e conduzir as aulas de forma independente, aplicando a metodologia
              Conversation Experience.
            </span>
            <span class="ml-4 mt-4"
              ><strong>A Pitch</strong> atua como a base de suporte do
              ecossistema, oferecendo
              <strong
                >conteúdos pedagógicos, recursos tecnológicos e didáticos
                exclusivos, materiais estruturados, treinamentos e apoio
                contínuo</strong
              >, além disso indicamos alunos para os professores licenciados
              sempre que houver demanda. O melhor de tudo,
              <strong>sem nenhum investimento inicial </strong>para o professor
              licenciado!</span
            >
            <span class="ml-4 mt-4">
              Ficou interessado na possibilidade
              <strong>
                de ganhar mais de 10 mil reais trabalhando de casa e com
                horários flexíveis?</strong
              >
            </span>
            <div class="ml-4 mt-10">
              <v-btn color="primary" rounded @click="openWhatsApp()">
                <strong
                  >👉Quero conversar sobre essa oportunidade
                </strong></v-btn
              >
            </div>
          </v-col>
        </v-col>
        <v-col
          cols="12"
          md="6"
          sm="6"
          class="d-flex align-center jutify-center"
        >
          <v-img src="@/assets/images/building.png" />
        </v-col>
      </v-row>
    </v-container>
    <Footer @scrollTo="scroll" />
  </div>
</template>
<script>
import TopMenu from "@/components/homepage/TopMenu.vue";
import Footer from "@/components/homepage/Footer.vue";
export default {
  name: "PartnerPage",
  components: {
    TopMenu,
    Footer,
  },
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    scroll() {
      this.$router.push({ path: "/" });
    },
    openWhatsApp() {
      window.open(
        "https://api.whatsapp.com/send?phone=553298602805&text=Olá gostaria de ser um professor licenciado!",
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.bolder {
  font-weight: bold;
}

.gradient {
  font-size: 36px;
  background: linear-gradient(to right, #e8276f, #9923cd);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
